goog.provide("shadow.js.shim.module$$js_temporal$polyfill$Temporal_Now");
shadow.js.shim.module$$js_temporal$polyfill$Temporal_Now = shadow.js.require(1, {})["Temporal"]["Now"];
